import React from "react";

const Footer = () => {
  return (
    <footer className="bg-green-700 text-white py-4 text-center mt-6">
      <p>© 2025 ग्रामपंचायत -पिपरा, पंचायत समिती : उमरेड, जिल्हा नागपूर  
 | संपर्क: 8669393515</p>
    </footer>
  );
};

export default Footer;
